import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export type JoinBoardModalInviterFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id' | 'fullName'>
  & { nonPublic?: Types.Maybe<(
    { __typename: 'Member_NonPublic' }
    & Pick<Types.Member_NonPublic, 'fullName'>
  )> }
);

export const JoinBoardModalInviterFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JoinBoardModalInviter' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nonPublic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseJoinBoardModalInviterFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      JoinBoardModalInviterFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseJoinBoardModalInviterFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<JoinBoardModalInviterFragment>,
    'data'
  > {
  data?: JoinBoardModalInviterFragment;
}

export const useJoinBoardModalInviterFragment = ({
  from,
  returnPartialData,
  ...options
}: UseJoinBoardModalInviterFragmentOptions): UseJoinBoardModalInviterFragmentResult => {
  const result = Apollo.useFragment<JoinBoardModalInviterFragment>({
    ...options,
    fragment: JoinBoardModalInviterFragmentDoc,
    fragmentName: 'JoinBoardModalInviter',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as JoinBoardModalInviterFragment };
};
